import { UserModuleModel, UserModulesExists } from './../../shared/models/general-model';
import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { Modules } from "../../shared/models/general-model";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: "app-whitelisting",
  templateUrl: "./whitelisting.component.html",
  styleUrls: ["./whitelisting.component.scss"],
})
export class WhitelistingComponent implements OnInit {
  min: number;
  max: number;
  searchPage = 1;
  options: Array<any> = [];
  errorMsg = "";
  modalRef: BsModalRef;
  message: string;
  getPaginationCount;
  show: boolean;
  importFile: boolean = false;
  editFile: boolean = false;
  constructor(
    private xls: XlsxService,
    private config: ApiConfiguration,
    private service: ApiService,
    private toast: ToastClientService,
    public exportExcelService: ExportExcelService,
    private modalService: BsModalService,
    public modalService1: NgbModal,
    public alertService: AlertService,
    private xlsx: XlsxService,
    private uploadFile: UploadZipService,
    public ngxService: NgxUiLoaderService
  ) {


    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getList();
        this.getUserExportList();
      }
    });
  }
  public headers;
  public columns;
  public save = true;
  public notice = true;
  public month;
  public year;
  public ro_name = [];
  public moduleId;
  public modules: Modules[];
  public userList: any[];
  public excel = [
    {
      outlet_code: "",
    },
  ];


  public userModuleData: UserModuleModel[] = [];
  public userModuleIsExists: UserModulesExists[] = [];
  public excelReportData: any[];

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {
      console.log(error);
    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) { }
  }

  getYears() {
    (this.min = 2019), (this.max = new Date().getFullYear());
    let options = "<option>Select Year</option>";
    for (var i = this.min; i <= this.max; i++) {
      options += '<option value="' + i + '">' + i + "</option>";
      this.options.push(i);
    }
    this.options.reverse();
  }

  ngOnInit() {
    this.show = false
    this.month = 0
    this.year = 0
    this.service.getHeaders(this.config.getModule).subscribe((res: any) => {
      this.modules = res.body.data;
    });
    this.getYears();
  }

  whitelistedUsersList: any[] = [];
  search;

  fileName: string = "";
  excelData: any[];
  importExcel(event) {

    this.editFile = true;
    this.importFile = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
    }
    this.xls.uploadXlsx(event).then((res: any) => {
      this.headers = res.headers;
      this.columns = res.data;
      this.save = false;
      this.notice = false;
      this.excelData = res;
      console.log(this.excelData)
      this.editFile = false;
    });
  }


  xlsxView(data) {

    console.log("###", data)
    // data.apiHeaders = this.brandsListHeaders;
    let modalRef = this.modalService1.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        if (result.length > 0) {
          if (this.importFile == false) return this.uploadMultiData(result);
          if (this.editFile == false) return this.updateMultiData(result);

        }
      },
      (reason) => { }
    );
  }

  uploadMultiData(data) {
    this.enableUploadDiv(data);
  }

  enableUploadDiv(data) {
    let payload = {
      month: this.month,
      year: this.year,
      excel_data: data,
    };
    this.uploadFile.changeMessage({
      status: "upload",
      data: payload,
      url: this.config.createWhitelist,
      module: "User Modules",
      zip: "no",
      excelname: "User Modules Excel",
    });
    this.fileName = "";
    this.importFile = false;
    this.editFile = false;
  }

  getList() {
    this.show = true
    this.headers = [];
    this.columns = [];
    this.save = true;
    this.notice = true;
    this.loaderStart();
    this.service
      .getHeaders(
        this.config.getUserModules +
        "?month=" +
        this.month +
        "&year=" +
        this.year
      )
      .subscribe(async (res: any) => {

        this.userList = await res.body.data;
        this.show = false;

        this.loaderDismiss();
        console.log(this.userList);
        this.whitelistedUsersList = [];
        const map = new Map();
        this.userModuleData = [];
        for (const item of this.userList) {
          if (!map.has(item.user_id)) {
            map.set(item.user_id, item);
            let data: UserModuleModel = new UserModuleModel();
            data.ro_code = item.ro_code;
            data.ro_name = item.ro_name;
            data.id = item.id;
            data.user_detail_name = item.user_detail_name;
            data.module_month = item.module_month;
            data.module_year = item.module_year;
            data.user_id = item.user_id;
            data.user_modules = this.userList.filter(i => i.user_id == item.user_id);
            this.userModuleIsExists = [];
            for (let { id } of this.modules) {
              let found = data.user_modules.findIndex(x => x.module_id === id);
              let userModulesExists: UserModulesExists = new UserModulesExists();
              if (found >= 0) {
                userModulesExists.isExist = true;
                userModulesExists.status = (data.user_modules.find(x => x.module_id === id).status) == true ? 1 : 0;
                userModulesExists.module_id = id;
                userModulesExists.id = (data.user_modules.find(x => x.module_id === id).id);
                userModulesExists.user_id = data.user_id;
                userModulesExists.module_month = data.module_month;
                userModulesExists.module_year = data.module_year;
                userModulesExists.show = false;
                userModulesExists.statusString = userModulesExists.status == 1 ? "Active" : "Inactive";
                if (
                  data.module_year == new Date().getFullYear() &&
                  data.module_month == new Date().getMonth() + 1
                ) {
                  userModulesExists.show = true;
                }
              } else {
                userModulesExists.isExist = false;
                userModulesExists.status = 0;
                userModulesExists.module_id = id;
                userModulesExists.id = 0;
                userModulesExists.user_id = 0;
                userModulesExists.module_month = 0;
                userModulesExists.module_year = 0;
                userModulesExists.show = false;
                userModulesExists.statusString = "NA";
                if (
                  data.module_year == new Date().getFullYear() &&
                  data.module_month == new Date().getMonth() + 1
                ) {
                  userModulesExists.show = false;
                }
              }
              this.userModuleIsExists.push(userModulesExists);
            }
            data.modules = this.userModuleIsExists;
            this.userModuleData.push(data);
          }

        }
        console.log(this.userModuleData);
        console.log(this.whitelistedUsersList);
        this.getTargetPageCount();
      });

  }

  getUserExportList() {

    this.service
      .getHeaders(
        this.config.getAllUserModules +
        "?month=" +
        this.month +
        "&year=" +
        this.year
      )
      .subscribe((res: any) => {
        this.excelReportData = res.body.data;

      },
        (err) => {
          console.log(err);
          this.toast.Error(err);

        });
  }
  onSave() {
    this.errorMsg = "";

    if (this.month == 0 && this.year == 0) {
      this.errorMsg = `Please select month & year`;
      this.alertService.error(this.errorMsg);
      this.clearSuccess();
      return;
    }

    // if (this.year < new Date().getFullYear()) {
    //   this.errorMsg = `You can't whitelist for the past year`;
    //   this.alertService.error(this.errorMsg);
    //   this.clearSuccess();
    //   return;
    // }


    let payload = {
      month: this.month,
      year: this.year,
      excel_data: this.columns,
    };

    if (this.importFile == false) return this.xlsxView(this.excelData)
    if (this.editFile == false) return this.xlsxView(this.editexcelData);

  }

  downloadExcel() {
    if (this.modules.length > 0) {


      this.exportExcelService.exportWhiteListExcel(this.modules);
    }
  }

  paginationClick(e) {
    console.log(e);
    this.searchPage = e;
    this.getList();
  }

  getTargetPageCount(): void {
    this.loaderStart();
    this.service
      .getHeaders(
        this.config.getUserModules +
        "?month=" +
        this.month +
        "&year=" +
        this.year
      )
      .subscribe((res: any) => {
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        console.log("here", this.getPaginationCount);
        this.loaderDismiss();
      });
  }

  loading: boolean = false;

  changeOutletStatus(item) {
    item.status = item.status == false ? 0 : 1;
    this.service
      .put(this.config.updateUserModules + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.getList();
        this.alertService.success(res.data.message);
        this.clearSuccess();
      });
  }


  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  exportUserModules(reportData) {
    this.exportExcelService.exportWhiteListReportExcel(reportData);
  }


  EditfileName: string = "";
  editexcelData: any[];
  EditimportExcel(event) {
    this.importFile = true;
    this.editFile = false;
    if (event.target.files.length > 0) {
      this.EditfileName = event.target.files[0].name;
    }
    this.xls.uploadXlsx(event).then((res: any) => {
      this.headers = res.headers;
      this.columns = res.data;
      this.save = false;
      this.notice = false;
      this.editexcelData = res;
      console.log(this.editexcelData)
      // this.importFile = false;
    });
  }

  UploadExcel(data) {

    let payload = {
      month: this.month,
      year: this.year,
      excel_data: data,
    };
    this.uploadFile.changeMessage({
      status: "upload",
      data: payload,
      url: this.config.updateWhitelist,
      module: "User Modules",
      zip: "no",
      excelname: "User Modules Excel",
    });
    this.EditfileName = "";
    this.importFile = false;
    this.editFile = false;
  }
  updateMultiData(data) {
    this.UploadExcel(data);
  }

}
